import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_LOG_LOADING = 'GET_LOG_LOADING';
export const GET_LOG_SUCCESS = 'GET_LOG_SUCCESS';
export const GET_LOG_REJECT = 'GET_LOG_REJECT';

//* ACTIONS ------------------------------------------------
export const getLogLoading = () => ({ type: GET_LOG_LOADING });
export const getLogSuccess = (payload) => ({ type: GET_LOG_SUCCESS, payload });
export const getLogReject = (payload) => ({ type: GET_LOG_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getLogRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Logs/web/GetLogs`, options);
};

